<template>
  <div id="app" :class="{ 'has-site-header': !$route.meta.hideHeader }">
    <site-header v-if="!$route.meta.hideHeader" />
    <transition
      name="fade"
      mode="out-in"
      v-if="!isUCBrowser"
      @before-enter="scrollToTop"
    >
      <router-view />
    </transition>
    <router-view v-else />
    <!-- <ad-pop /> -->
  </div>
</template>

<script>
import SiteHeader from '@/website/components/SiteHeader'
export default {
  name: 'Web',
  components: { SiteHeader },
  data() {
    return {
      waitTimeOut: null,
      isUCBrowser: false
    }
  },
  created() {
    this.isUCBrowser = navigator.userAgent.indexOf('UCBrowser') > -1
  },
  mounted() {
    var that = this
    this.waitTimeOut = setTimeout(function () {
      reportToRlog('website_home_wait')
      that.waitTimeOut = null
    }, 5)
  },
  watch: {
    $route() {
      if (this.isUCBrowser) {
        this.$nextTick(this.scrollToTop)
      }
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style></style>
<style>
.fade-enter-active {
  transition: opacity 0.2s ease-out;
}
.fade-leave-active {
  transition: opacity 0.2s ease-in;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style>
@import '../assets/css/icon.css';
#app {
  width: 100%;
  height: 100%;
}
#app.has-site-header {
  box-sizing: border-box;
  padding-top: 64px;
}
html,
body,
div,
p,
h1,
h2,
h3,
h4,
h5,
ol,
ul,
li,
dl,
dt,
dd,
form,
input,
textarea,
select,
span,
table,
tr,
td,
img {
  margin: 0;
  padding: 0;
  border: 0;
}
html,
body {
  background: rgba(255, 255, 255, 0.94);
  color: rgba(122, 122, 122, 1);
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Source Han Sans SC',
    'Noto Sans CJK SC', 'Helvetica Neue', sans-serif;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-font-smoothing: antialiased;
  font-size: 0.32rem;
  color: rgba(122, 122, 122, 1);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch; /* 解决ios滑动不流畅问题 */
}

body {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
*:focus,
*:hover {
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
:not(input, textarea) {
  -webkit-touch-callout: none;
  -webkit-user-select: element;
  user-select: element;
}
input,
textarea {
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
  -webkit-appearance: none;
}
input,
textarea {
  outline: none;
  border: none;
  border-radius: 0;
}
input::-moz-focus-inner,
input::-webkit-focus-inner,
input::focus-inner {
  border: 0;
}
textarea {
  resize: none;
}
ul,
ol,
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #333;
  outline: none;
}
a,
input {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
a:focus,
input:focus {
  outline: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

div#trans-tooltip,
div#tip-left-top,
div#tip-top,
div#tip-right-top,
div#tip-right,
div#tip-right-bottom,
div#tip-bottom,
div#tip-left-bottom,
div#tip-left,
div#trans-content,
div#tip-arrow-bottom,
div#tip-arrow-top {
  display: none !important;
}

.wljb {
  display: block;
  background: url(https://shared.ydstatic.com/dict/v2016/entry/wljb.jpg)
    no-repeat;
  width: 130px;
  height: 40px;
  overflow: hidden;
}
</style>
